import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-686 (4.1 name).
export const NameScreen = () => (
  <StubScreen id="name" heading="Wie lautet Ihr Name?" />
);
